import { useQuery } from '@tanstack/react-query';
import { get } from '../../lib/api';

const shouldTranslate = () => {
  const CLIENT_ADMIN_PATHS = ['/client_admin/tiles', '/client_admin/campaigns'];
  const path = window.location.pathname;
  return !CLIENT_ADMIN_PATHS.includes(path);
};

export const useGetTile = ({ tileId, preview = false, campaignUuid }) => {
  let url = `/api/v1/tiles/${tileId}?translate=${shouldTranslate()}`;

  // Preview reads are authorized by the campaign uuid (the preview link's
  // secret), so it has to travel with the request.
  if (preview) url = url.concat(`&preview=true&campaign_uuid=${campaignUuid}`);

  const {
    data = { campaignContainer: '' },
    isLoading,
    refetch,
    isError,
    isFetching,
  } = useQuery(['getTile', tileId], () => {
    if (!tileId) return {};
    return get(url);
  });

  if (isError) window.location.replace('/');

  return { data, isLoading, refetch, isFetching };
};
